import CURPError from './CURPError';
class CURPAlreadyRegistered extends CURPError {
    constructor(curp, options) {
        super('CURPAlreadyRegistered', `Investor with curp: ${curp} is already registered`, options);
    }
}
export default CURPAlreadyRegistered;
